export default "__VITE_ASSET__533985ae__"